import { PLACEHOLDERS, placeholderStyle } from "@shared/unified-tiptap/placeholders"
import { SECTION_COLOR_MAP } from "@shared/util/colors"
import { NodeViewContent, NodeViewWrapper, type ReactNodeViewProps } from "@tiptap/react"
import { type ExtensionCardTitleAttrs } from "./card-title-extension"

export const CardTitleComponent = ({ node }: ReactNodeViewProps) => {
  const attrs = node.attrs as ExtensionCardTitleAttrs

  // min-w keeps a click target & room for the "Title" placeholder when empty. A long word
  // breaks at the row edge instead of overflowing; hyphens-auto upgrades that to a real
  // hyphen where supported.
  const titleClassName =
    "min-h-[1.125rem] min-w-[50px] text-[1.125rem] font-bold break-words hyphens-auto leading-tight"

  return (
    <NodeViewWrapper className="select-none">
      <NodeViewContent
        className={titleClassName}
        style={{
          color: SECTION_COLOR_MAP[attrs.color],
          ...placeholderStyle(PLACEHOLDERS.cardTitle),
        }}
      />
    </NodeViewWrapper>
  )
}
